"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "zambrone": {
    "6cffbd21": [{
      "hkey": "cdee6a89",
      "slug": "zambrone",
      "name": "Zambrone",
      "primary": true,
      "skipSearch": false
    }],
    "calate-potame": [{
      "hkey": "cdee6a89",
      "slug": "zambrone",
      "name": "Zambrone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6618bf5b": [{
      "hkey": "cf7c495d",
      "slug": "daffina-daffinacello",
      "name": "Daffinà-Daffinacello",
      "primary": true,
      "skipSearch": false
    }],
    "daffina": [{
      "hkey": "cf7c495d",
      "slug": "daffina-daffinacello",
      "name": "Daffinà-Daffinacello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "e29897f1": [{
      "hkey": "cf7c495d",
      "slug": "daffina-daffinacello",
      "name": "Daffinà-Daffinacello",
      "primary": true,
      "skipSearch": false
    }],
    "daffinacello": [{
      "hkey": "cf7c495d",
      "slug": "daffina-daffinacello",
      "name": "Daffinà-Daffinacello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "zambrone"
    }],
    "74e1de11": [{
      "hkey": "cdee6a89",
      "slug": "zambrone",
      "name": "Zambrone",
      "primary": true,
      "skipSearch": false
    }],
    "ferroviaria": [{
      "hkey": "cdee6a89",
      "slug": "zambrone",
      "name": "Zambrone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4e57f13b": [{
      "hkey": "cdee6a89",
      "slug": "zambrone",
      "name": "Zambrone",
      "primary": true,
      "skipSearch": false
    }],
    "perdipitti": [{
      "hkey": "cdee6a89",
      "slug": "zambrone",
      "name": "Zambrone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1d6b64fa": [{
      "hkey": "cdee6a89",
      "slug": "zambrone",
      "name": "Zambrone",
      "primary": true,
      "skipSearch": false
    }],
    "priscopio": [{
      "hkey": "cdee6a89",
      "slug": "zambrone",
      "name": "Zambrone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;